<template>
  <div class="portlet light">
    <div class="portlet-title">
      <div class="caption caption-md">
        <i class="icon-globe theme-font hide"></i>
        <span class="caption-subject bold uppercase">Messaging</span>
      </div>
      <div class="actions">
        <a class="btn btn-circle btn-icon-only btn-default" @click.prevent="getExport">
          <i class="icon-cloud-download"></i>
        </a>
      </div>
    </div>
    <div class="portlet-body">
      <form class="form-horizontal" role="form" @submit.prevent="onSearch">
        <div class="form-body">
          <div class="form-group form-md-line-input has-warning">
            <div class="col-md-12">
              <div class="input-group">
                <div class="input-group-control input-icon">
                  <i class="fa fa-search"></i>
                  <input type="text" class="form-control" placeholder="Type to search..." v-model="search">
                  <div class="form-control-focus"></div>
                </div>
                <span class="input-group-btn btn-right">
                       <button class="btn green mt-ladda-btn ladda-button search-msg-btn" ref="searchBtn" type="submit" data-style="expand-left">
                          <span class="ladda-label">Search</span>
                       </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </form>
      <form role="form" class="form-horizontal" @submit.prevent="submit">
        <div class="scroll-section" style="height: 300px; overflow: hidden; padding-right: 10px" v-bar>
          <ul class="chats" v-chat-scroll>
            <template v-for="message in messages">
              <li :class="(message.type === 'inbound') ? 'in' : 'out'">
                <avatar :username="(message.type === 'inbound') ? message.participant.fullName : message.user.fullName"
                        :src="(message.type === 'inbound') ? message.participant.avatar : message.user.avatar" :size="45" :rounded="true"
                        color="#d09f23" class="avatar" backgroundColor="#eef1f5"></avatar>
                <div class="message">
                  <span class="arrow"> </span>
                  <b v-if="message.status === 'system_administrator'">System Administrator</b>
                  <b v-else> {{ (message.type === 'inbound') ? message.participant.fullName : message.user.fullName }} </b>
                  <span class="datetime"> at {{ message.createdAt | formatDateForMessage }} </span>
                  <span class="body"> {{ message.body }} </span>
                </div>
              </li>
<!--              <template v-if="message.status === 'error'">-->
<!--                <li class="in">-->
<!--                  <avatar username="System Administrator"-->
<!--                          :size="45" :rounded="true"-->
<!--                          color="#d09f23" class="avatar" backgroundColor="#eef1f5"></avatar>-->
<!--                  <div class="message">-->
<!--                    <span class="arrow"> </span>-->
<!--                    <b> System Administrator </b>-->
<!--                    <span class="datetime"> at {{ message.createdAt.date | formatDate }} </span>-->
<!--                    <span class="body"> {{ message.error }} </span>-->
<!--                  </div>-->
<!--                </li>-->
<!--              </template>-->
            </template>
          </ul>
        </div>
        <div class="chat-form">
          <div class="input-cont">
            <small><strong>Reply to</strong> <i class="fa fa-mobile-phone"></i> {{ replyPhone }}</small>
            <input class="form-control" type="text" placeholder="Type a message here..." v-model="body" data-style="expand-left">
          </div>
          <div class="btn-cont">
            <span class="arrow green"> </span>
            <button class="btn icn-only green mt-ladda-btn ladda-button send-btn-submit" data-style="zoom-in">
              <i class="fa fa-check icon-white"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';
    import Avatar from '@/components/menu/Avatar.vue';

    export default {
        components: {
            Avatar
        },
        data() {
            return {
                body: '',
                search: '',
                idleTime: 60,
                idleCountdown: null,
                idleTimeout: false
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                messages: 'getMessages',
                replyPhone: 'getReplyPhone',
            })
        },
        methods: {
            ...mapActions({
                getMessagesAction: 'GET_MESSAGES_ACTION',
                submitMessageAction: 'SUBMIT_MESSAGES_MESSAGE_ACTION',
                refreshUser: 'GET_USER_DATA_REFRESH_ACTION',
                getExportFile: 'SMS_MESSAGES_REPORT_ACTION'
            }),
            startIdleCountdown: function () {
                this.idleCountdown = this.idleTime;
                this.setIdleTimer = setInterval(this.idleTimer, 1000);
            },
            idleTimer: function () {
                this.idleCountdown = this.idleCountdown - 1;
                if (!this.idleCountdown) {
                    clearInterval(this.setIdleTimer);
                    this.idleTimeout = !this.idleTimeout;
                }
            },
            idleReset: function () {
                clearInterval(this.setIdleTimer);
                this.startIdleCountdown();
            },
            submit() {
                const button = Ladda.create(document.querySelector('.send-btn-submit'));
                this.submitMessageAction({id: this.$route.params.id, body: this.body, button}).then((res) => {
                  this.getMessagesAction({id: this.$route.params.id})
                })
                this.body = '';
            },
            onSearch() {
                const button = Ladda.create(document.querySelector('.search-msg-btn'));
                this.getMessagesAction({id: this.$route.params.id, search: this.search, button})
            },
            getExport() {
                this.getExportFile({id: this.$route.params.id, search: this.search, timezone: this.user.time_zone});
            }
        },
        created() {
            this.getMessagesAction({id: this.$route.params.id})
        },
        mounted() {
            this.startIdleCountdown();
            this.refreshUser();
        },
        watch: {
            '$route': function () {
                this.search = '';
            },
            'idleCountdown': function () {
                if (this.idleCountdown <= 0) {
                    this.idleReset();
                    this.getMessagesAction({id: this.$route.params.id, search: this.search})
                }
            },
            '$route.params.id': function () {
                this.getMessagesAction({id: this.$route.params.id})
            }
        }
    }
</script>
<style scoped>
  small {
    margin-bottom: 8px;
    display: block;
  }

  .arrow.green {
    border-right: 8px solid #d09f24 !important;
  }

  .chat-form .btn-cont:hover .btn {
    background-color: #d09f24;
  }

  .btn.green:not(.btn-outline):hover {
    border-color: #d09f24;
  }

  .portlet > .portlet-title > .actions .btn-icon-only.btn-default > i {
    font-size: 14px !important;
  }
</style>



// WEBPACK FOOTER //
// Messages.vue?7b946bc0